import Decimal from 'decimal.js';

const BAHT_PER_GRAM = 0.0656;
const GRAM_PER_BAHT = 15.244;

const GRAM_PER_BAHT_ORNAMENT = 15.2;

// export function convertGoldWeight(value: number, toUnit: 'baht' | 'grams', isOrnament: boolean): number {
//   const bahtPerGram = BAHT_PER_GRAM;

//   if (toUnit === 'grams') {
//     // Convert baht to grams
//     return value / bahtPerGram;
//   }

//   return value * bahtPerGram;
// }

export function convertGold(
  value: number,
  toUnit: 'weightBaht' | 'weightGrams' | 'priceBaht' | 'priceGrams',
  isOrnament?: boolean
): number {
  const decimalValue = new Decimal(value);

  switch (toUnit) {
    case 'weightBaht':
      return decimalValue.div(isOrnament ? GRAM_PER_BAHT_ORNAMENT : GRAM_PER_BAHT).toNumber();
    case 'weightGrams':
      return decimalValue.mul(GRAM_PER_BAHT).toNumber();
    case 'priceBaht':
      return decimalValue.div(BAHT_PER_GRAM).toNumber();
    case 'priceGrams':
      return decimalValue.mul(BAHT_PER_GRAM).toNumber();
    default:
      return 0;
  }
}
